export default __webpack_public_path__ + "static/media/pantry1-afterF-2048w.e3467e2b.avif";